module.exports = __webpack_public_path__ + "img/arrow.461ebfd4.svg";